import { LaborTypeSummaryModel } from "../ApiResources";

// Typescript User-Defined Type Guard
export function isInstanceOfLaborTypeSummaryModel(
  object: any
): object is LaborTypeSummaryModel {
  return "id" in object && "name" in object;
}
